import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy';
import { Icon } from '@kontentino/ui';
import { ActionContext, createAction } from 'actions';
import i18n from 'app/utils/i18n';
import { modalRoutes } from 'constants/routes';
import { UserPermission } from 'constants/userPermission';
import { PostDetail } from 'types/PostDetail';

export const duplicatePost = (context: ActionContext) =>
  createAction(
    {
      id: 'duplicate-post',
      label: () => i18n.t('duplicate'),
      icon: <Icon icon={faCopy} />,
      scopes: UserPermission.POST_DUPLICATE,
      perform: ({ id }: { id: PostDetail['id'] }) => {
        context.modalHistory.push({
          hash: modalRoutes.DUPLICATE_POSTS,
          search: `?posts=${id}`,
        });
      },
    },
    context,
  );
